export default __webpack_public_path__ + "static/media/s_gts2.6c04e369.jpg";